import { Button, Form, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import ConfirmDeleteElementDialog from "./ConfirmDeleteElementDialog";
import { useFormContext } from "./formElements";

export default function TableOffer(props) {
  const element = props.value;
  const showLpCol = element.showLpCol === undefined ? true : element.showLpCol;
  const copyOnAdd = element.copyOnAdd === undefined ? false : element.copyOnAdd;
  const columns = element.columns;
  const values = element.value;
  const { onChange, onDelete, tableTextAsTextarea } = useFormContext();
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);

  const getRow = (index) => {
    let cols = [];
    const data = values[index] || columns;

    for (let x in data) {
      const column = data[x];

      if (column.type === "checkbox") {
        cols.push(
          <td className={"p-0"} key={x} width={column.defaultWidth}>
            <Form.Check
              className="m-2"
              type="checkbox"
              checked={column.value}
              onChange={(event) => {
                data[x] = { ...column, value: event.target.checked };
                element.value[index] = data;
                onChange(element);
              }}
            />
          </td>
        );
      } else if (column.type === "select") {
        cols.push(
          <td className={"p-0"} key={x}>
            <Form.Select
              className={"border-0 bg-transparent"}
              defaultValue={column.value}
              onChange={(event) => {
                data[x] = { ...column, value: event.target.value };
                element.value[index] = data;
                onChange(element);
              }}
            >
              {column.options.map((opt) => {
                return (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                );
              })}
            </Form.Select>
          </td>
        );
      } else if (column.type === "autocomplete") {
        cols.push(
          <td className={"p-0"} key={x}>
            <Form.Control
              className="border-0 bg-transparent"
              list={`options-${x}`}
              defaultValue={column.value}
              onChange={(event) => {
                data[x] = { ...column, value: event.target.value };
                element.value[index] = data;
                onChange(element);
              }}
            />
            <datalist id={`options-${x}`}>
              {column.options.map((opt) => (
                <option key={opt} value={opt} />
              ))}
            </datalist>
          </td>
        );
      } else if (column.type === "textarea") {
        cols.push(
          <td className={"p-0"} key={x}>
            <Form.Control
              className={"border-0 bg-transparent"}
              as={"textarea"}
              type={column.type}
              value={column.value}
              placeholder={column.label}
              onChange={(event) => {
                data[x] = { ...column, value: event.target.value };
                element.value[index] = data;
                onChange(element);
              }}
            />
          </td>
        );
      } else {
        const renderAsTextarea = tableTextAsTextarea && column.type === "text";
        cols.push(
          <td className={"p-0"} key={x}>
            <Form.Control
              className={`border-0 bg-transparent${renderAsTextarea ? " offer-table-cell-control" : ""}`}
              as={renderAsTextarea ? "textarea" : undefined}
              rows={renderAsTextarea ? 1 : undefined}
              type={column.type}
              value={column.value}
              placeholder={column.label}
              onChange={(event) => {
                data[x] = { ...column, value: event.target.value };
                element.value[index] = data;
                onChange(element);
              }}
            />
          </td>
        );
      }
    }

    const handleDeleteRow = () => {
      element.value.splice(index, 1);
      onChange({ ...element });
    };

    return (
      <tr key={index}>
        {showLpCol && <td>{index + 1}</td>}
        {cols}
        <td>
          <div className={"btn-close"} onClick={handleDeleteRow}></div>
        </td>
      </tr>
    );
  };

  const handleAddRow = () => {
    let rowDataToAdd;
    if (copyOnAdd) {
      rowDataToAdd = values[values.length - 1] ?? columns;
    } else {
      rowDataToAdd = columns;
    }

    element.value.push([...rowDataToAdd]);
    onChange(element);
  };

  const handleSetTotalPrice = (event) => {
    element.total = event.target.value;
    onChange(element);
  };

  const handleShowTotalAfterDiscount = () => {
    element.totalAfterDiscount = "";
    onChange(element);
  };

  const handleSetTotalAfterDiscount = (event) => {
    element.totalAfterDiscount = event.target.value;
    onChange(element);
  };

  const handleRemoveTotalAfterDiscount = () => {
    delete element.totalAfterDiscount;
    onChange(element);
  };

  const getEmptyCells = (reservedCells = 0) => {
    const visibleColumnsCount = columns.length + (showLpCol ? 1 : 0) + 1;
    return Array.from({ length: visibleColumnsCount - 4 - reservedCells }).map((_, index) => (
      <td key={index}></td>
    ));
  };

  return (
    <div className={"m-2"}>
      <div className="d-flex align-items-center justify-content-between pb-2">
        <h5>{element.label}</h5>
        {element.deletable === true ? (
          <Button variant="outline-danger" size="sm" onClick={() => setShowDeleteDialog(true)}>
            <FontAwesomeIcon icon={faTrash} />
          </Button>
        ) : null}
      </div>
      <ConfirmDeleteElementDialog
        show={showDeleteDialog}
        onClose={() => setShowDeleteDialog(false)}
        onConfirm={() => onDelete(element)}
      />
      <Table striped bordered hover>
        <thead>
          <tr>
            {showLpCol && <td>L.p.</td>}
            {columns.map((col, i) => {
              return (
                <th key={i} className="p-0">
                  <Form.Control
                    className={"border-0 bg-transparent"}
                    type="text"
                    value={col.label}
                    onChange={(event) => {
                      element.columns[i] = {
                        ...col,
                        label: event.target.value,
                      };
                      onChange(element);
                    }}
                  />
                </th>
              );
            })}
            <th></th>
          </tr>
        </thead>
        <tbody>
          {values.map((row, index) => {
            return getRow(index);
          })}
          <tr>
            <td colSpan={3}>Łącznie</td>
            <td className={"p-0"}>
              <Form.Control
                className={"border-0 bg-transparent"}
                value={element.total}
                onChange={handleSetTotalPrice}
              />
            </td>
            {getEmptyCells()}
          </tr>
          {element.totalAfterDiscount !== undefined ? (
            <tr>
              <td colSpan={3}>Łącznie po rabacie</td>
              <td className={"p-0"}>
                <Form.Control
                  className={"border-0 bg-transparent"}
                  value={element.totalAfterDiscount}
                  onChange={handleSetTotalAfterDiscount}
                />
              </td>
              {getEmptyCells(1)}
              <td>
                <div className={"btn-close"} onClick={handleRemoveTotalAfterDiscount}></div>
              </td>
            </tr>
          ) : null}
        </tbody>
      </Table>
      <Button variant={"outline-secondary"} onClick={handleAddRow}>
        <FontAwesomeIcon icon={faPlus} /> dodaj wiersz
      </Button>
      {element.totalAfterDiscount === undefined ? (
        <Button variant={"outline-secondary"} className="ms-2" onClick={handleShowTotalAfterDiscount}>
          <FontAwesomeIcon icon={faPlus} /> Łącznie po rabacie
        </Button>
      ) : null}
    </div>
  );
}
